import { useEffect, useState } from "react";
import { SideModalContainerNew } from "../partials/sidemodalcontainer";
import Close from "../../assets/icons/close.svg";
import { useRequestStore } from "../../data/stores/loggerStore";
import { apiCall, numberWithCommas } from "../../data/useFetcher";
import moment from "moment";
import { effectivenessToHex } from "../reactflowchart/FlowCanvas";
import { Loader2, PlusIcon, Trash2, View } from "lucide-react";
import { useNavigate } from "react-router-dom";
// import useAuthStore from "../../data/stores/authStore";
import toast from "react-hot-toast";

const DetailsModal = ({ handleClose, detail }) => {
  const [datum, setDatum] = useState<any>(null),
    { dataSystemAll }: any = useRequestStore();

  useEffect(() => {
    dataSystemAll?.docs?.map((it: any) => it?._id === detail && setDatum(it));
  }, [detail, dataSystemAll]);

  // State to track the active tab
  const [activeTab, setActiveTab] = useState("about");
  const handleTabClick = (tabId) => {
      setActiveTab(tabId);
    },
    { getDynamicLogger } = useRequestStore(),
    { effectivenessOrg }: any = useRequestStore();

  // console.log({ effectivenessOrg });

  useEffect(() => {
    if (!datum) return;
    apiCall({
      type: "get",
      url: `/api/v1/data-system/manage-effectivenesspurposelevel?datasystem=${
        datum?.erpModule
      }${
        datum?.organization
          ? `&organization=${datum?.organization?._id || datum?.organization}`
          : ""
      }`,
      getter: (d: any) => getDynamicLogger(d, "effectivenessOrg"),
    });
  }, [datum]);

  if (!datum) return null;

  const tabs = [
    { id: "about", label: "About" },
    { id: "data-collection", label: "Data Collection" },
    { id: "data-flow", label: "Data Flow" },
    { id: "external-data-sharing", label: "External Data Sharing" },
    { id: "fit-for-purpose", label: "Fit For Purpose" },
  ];
  const organizationEffectiveness = [
    {
      id: 1,
      name: "Kampala Capital City Authority - Uganda",
      effectiveness: "Effective",
      color: "green",
    },
    {
      id: 2,
      name: "Water and Sanitation Corporation - Rwanda",
      effectiveness: "Ineffective",
      color: "red",
    },
    {
      id: 3,
      name: "Kisumu Water and Sanitation company",
      effectiveness: "Moderately Effective",
      color: "orange",
    },
    {
      id: 4,
      name: "Capital City Authority",
      effectiveness: "Effective",
      color: "green",
    },
  ];

  const dataCollectionDetails = [
    {
      question: "Name of the tool used to collect data",
      answer: Array.isArray(datum?.toolUsedToCollectData)
        ? datum?.toolUsedToCollectData?.join(", ")
        : datum?.toolUsedToCollectData,
    },
    {
      question: "What technology is used to collect the information",
      answer: Array.isArray(datum?.informationCollectionTool)
        ? datum?.informationCollectionTool?.join(", ")
        : datum?.informationCollectionTool,
    },
    {
      question: "How often is data collected",
      answer: Array.isArray(datum?.oftenCollected)
        ? datum?.oftenCollected?.join(", ")
        : datum?.oftenCollected,
    },
    {
      question: "How well does the data collection tool serve its purpose?",
      answer: Array.isArray(datum?.dataCollectionToolPurposeServe)
        ? datum?.dataCollectionToolPurposeServe?.join(", ")
        : datum?.dataCollectionToolPurposeServe,
    },
  ];

  const dataFlowDetails = [
    {
      question: "Which department feeds data to this system*",
      answer: Array.isArray(datum?.deptsFeedDataSystem)
        ? datum?.deptsFeedDataSystem?.join(", ")
        : datum?.deptsFeedDataSystem,
    },
    {
      question: "Which system feeds data to this system*",
      answer: Array.isArray(datum?.systemsFeedDataSystem)
        ? datum?.systemsFeedDataSystem?.join(", ")
        : datum?.systemsFeedDataSystem,
    },
    {
      question: "Which department receives data from this system?",
      answer: Array.isArray(datum?.deptReceiveData)
        ? datum?.deptReceiveData?.join(", ")
        : datum?.deptReceiveData,
    },
    {
      question: "Which system receives data from this system?",
      answer: Array.isArray(datum?.systemReceiveData)
        ? datum?.systemReceiveData?.join(", ")
        : datum?.systemReceiveData,
    },
    {
      question: "What reports are produced for decision-making?",
      answer: Array.isArray(datum?.reportProduced)
        ? datum?.reportProduced?.join(", ")
        : datum?.reportProduced,
    },
  ];

  const externalDataSharingDetails = [
    {
      question: "Which KPI does this system inform?",
      answer: Array.isArray(datum?.systemInformKPI)
        ? datum?.systemInformKPI?.join(", ")
        : datum?.systemInformKPI,
    },
    {
      question: "Which area does this system inform?",
      answer: Array.isArray(datum?.systemInformArea)
        ? datum?.systemInformArea?.join(", ")
        : datum?.systemInformArea,
    },
    {
      question: "Which external system receives data from this system?",
      answer: datum?.systemReceiveData,
    },
    {
      question: "How effective is the communication with external systems?",
      answer: Array.isArray(datum?.systemCommunicationEffectiveness)
        ? datum?.systemCommunicationEffectiveness?.join(", ")
        : datum?.systemCommunicationEffectiveness,
    },
  ];

  const systemDetails = [
    {
      question: "Data system in use by the department",
      answer: datum?.erpModule,
    },
    {
      question: "Name of the system developer",
      answer: datum?.systemDeveloper,
    },
    {
      question: "Date of first installation",
      answer: datum?.dateInstalled
        ? moment(datum?.dateInstalled).format("MMMM D, YYYY")
        : "",
    },
    {
      question: "Amount paid for annual license fees or maintenance",
      answer: `${datum?.annualLicenseFeeCurrency || ""}${numberWithCommas(
        datum?.annualLicenseFee || ""
      )}`,
    },
  ];

  return (
    <div>
      <SideModalContainerNew>
        <div className="relative flex bg-[#FCFCFC] flex-col h-full ">
          <div
            style={{
              borderBottom: "1px solid #D9D9D9",
            }}
            className="min-h-16 w-full px-4 flex justify-between bg-white items-center"
          >
            <div>
              <h5 className="text-xl font-bold uppercase text-esblue">
                {datum?.erpModule}
              </h5>
              <small className="text-xs font-normal text-es-gray-100">
                {datum?.profile?.user?.departmentName}
              </small>
            </div>
            <img
              onClick={handleClose}
              className="cursor-pointer"
              src={Close}
              alt="close"
            />
          </div>
          <div className="px-6">
            <div
              style={{
                border: "1px solid #F2F4F7",
              }}
              className="my-4 h-14 w-full p-1 bg-[#F5F5F5] flex gap-3"
            >
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`h-full px-4 text-sm font-medium rounded-lg focus:outline-none ${
                    activeTab === tab.id
                      ? "bg-[#2070B8] text-white main-shadow main-border"
                      : "text-gray-600 hover:bg-gray-100"
                  }`}
                  onClick={() => handleTabClick(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className="">
              {activeTab === "about" && (
                <div>
                  <h4 className="text-base font-semibold text-sec">
                    About {datum?.erpModule}
                  </h4>
                  <p className="mt-2 font-normal text-sm text-es-gray-100">
                    Describe the main purpose of the system: <br />
                    {datum?.systemPurpose}
                  </p>
                  <div className="mt-4 space-y-4">
                    {systemDetails.map((it, idx) => (
                      <div key={idx} className="">
                        <h5 className="text-sm font-mediun text-[#344054]">
                          {it.question}
                        </h5>
                        <p className="text-sm font-medium text-[#667085] max-w-2xl">
                          {it.answer}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {activeTab === "data-collection" && (
                <div>
                  <h4 className="text-base font-semibold text-sec">
                    Data Collection
                  </h4>
                  <div className="mt-4 space-y-4">
                    {dataCollectionDetails.map((it, idx) => (
                      <div key={idx} className="">
                        <h5 className="text-sm font-mediun text-[#344054]">
                          {it.question}
                        </h5>
                        <p className="text-sm font-medium text-[#667085] max-w-2xl">
                          {it.answer}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {activeTab === "data-flow" && (
                <div>
                  <h4 className="text-base font-semibold text-sec">
                    Data Flow
                  </h4>
                  <div className="mt-4 space-y-4">
                    {dataFlowDetails.map((it, idx) => (
                      <div key={idx} className="">
                        <h5 className="text-sm font-mediun text-[#344054]">
                          {it.question}
                        </h5>
                        <p className="text-sm font-medium text-[#667085] max-w-2xl">
                          {it.answer}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {activeTab === "external-data-sharing" && (
                <div>
                  <h4 className="text-base font-semibold text-sec">
                    External Data Sharing
                  </h4>
                  <div className="mt-4 space-y-4">
                    {externalDataSharingDetails.map((it, idx) => (
                      <div key={idx} className="">
                        <h5 className="text-sm font-mediun text-[#344054]">
                          {it.question}
                        </h5>
                        <p className="text-sm font-medium text-[#667085] max-w-2xl">
                          {it.answer}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {activeTab === "fit-for-purpose" && (
                <div>
                  <h4 className="text-base font-semibold text-sec">
                    Fit For Purpose
                  </h4>
                  <div className="space-y-4 mt-4">
                    <div>
                      <h5 className="text-sm font-medium text-[#070D27]">
                        System Effectiveness (Fit-for-Purpose)
                      </h5>
                      <p className="mt-1 text-sm font-medium text-[#696969]">
                        <span
                          className={`font-bold`}
                          style={{
                            color: effectivenessToHex(
                              Array.isArray(datum?.effectivenessPurposeLevel)
                                ? datum?.effectivenessPurposeLevel?.[0]
                                : datum?.effectivenessPurposeLevel
                            ),
                          }}
                        >
                          {Array.isArray(datum?.effectivenessPurposeLevel)
                            ? datum?.effectivenessPurposeLevel?.[0]
                            : datum?.effectivenessPurposeLevel}
                          :
                        </span>{" "}
                        Data system is not capable or suited to its role with
                        significant challenges/barriers
                      </p>
                    </div>
                    <div>
                      <h5 className="text-sm font-medium text-[#070D27]">
                        Data Security
                      </h5>
                      <p className="mt-1 text-sm font-medium text-[#696969]">
                        <span
                          className="font-bold"
                          style={{
                            color: effectivenessToHex(
                              Array.isArray(datum?.dataSecurity)
                                ? datum?.dataSecurity?.[0]
                                : datum?.dataSecurity
                            ),
                          }}
                        >
                          {Array.isArray(datum?.dataSecurity)
                            ? datum?.dataSecurity?.[0]
                            : datum?.dataSecurity}
                          :
                        </span>{" "}
                        Basic security measures like encryption and access
                        control are lacking.
                      </p>
                    </div>
                    <div>
                      <h5 className="text-sm font-medium text-[#070D27]">
                        System Effectiveness as reported by other organisations
                      </h5>
                      <div className="space-y-3 mt-1">
                        {effectivenessOrg?.docs
                          // ?.filter(it => it?._id !== detail)
                          ?.map((org: any, i: number) => (
                            <div
                              className="flex justify-between items-center"
                              key={i}
                            >
                              <h6 className="text-sm underline font-normal text-[#2070B8]">
                                {org.organization?.user?.organizationName} -{" "}
                                {org?.organization?.country}
                              </h6>
                              <div
                                className={`h-6 px-4 flex gap-3 items-center ${
                                  org?.effectivenessPurposeLevel === "Effective"
                                    ? "bg-[#ECFDF3] text-[#027A48]"
                                    : org?.effectivenessPurposeLevel ===
                                      "Ineffective"
                                    ? "bg-[#FFFAEB] text-[#B45309]"
                                    : "bg-[#FEF3F2] text-[#B42318]"
                                } rounded-lg`}
                              >
                                <div
                                  className={` ${
                                    org?.effectivenessPurposeLevel ===
                                    "Effective"
                                      ? "bg-[#027A48]"
                                      : org?.effectivenessPurposeLevel ===
                                        "Ineffective"
                                      ? "bg-[#B45309]"
                                      : "bg-[#B42318]"
                                  } size-2 rounded-full`}
                                ></div>
                                <span className="text-sm font-medium">
                                  {org?.effectivenessPurposeLevel}
                                </span>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </SideModalContainerNew>
    </div>
  );
};

export default DetailsModal;

// Confirmation Modal Component
const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  loading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <img src={Close} alt="close" className="w-5 h-5" />
          </button>
        </div>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export const FocalDataSystemModal = ({ handleClose, detail }) => {
  const { getDynamicLogger, dataSystemAll }: any = useRequestStore(),
    [modal, setModal] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // State for confirmation modal
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  useEffect(() => {
    getDynamicLogger({}, "dataSystemAll");
    apiCall({
      type: "get",
      url: `/api/v1/data-system${detail ? `?profile=${detail?._id}` : ""}`,
      getter: (d: any) => getDynamicLogger(d, "dataSystemAll"),
      noToast: true,
    });
  }, [detail]);

  if (!detail) return null;

  const handleAdd = async (id: string) => {
    navigate(`/invitation/add-data-system/${id}`);
  };

  const handleDeleteClick = (id: string) => {
    setItemToDelete(id);
    setShowDeleteConfirmation(true);
  };

  const handleDeleteConfirm = async () => {
    if (itemToDelete) {
      setLoading(true);
      // Call the API to delete the contact
      const { response, errArr, errMsg } = await apiCall({
        type: "delete",
        url: `/api/v1/data-system/${itemToDelete}`,
      });

      // Check for errors
      if (errArr || errMsg) {
        // Error occurred, don't close modals
        // The apiCall function will handle showing the error toast
        toast.error(errMsg || "Failed to delete data system");
        setLoading(false);
        return;
      }

      // Success - close both modals and refresh data
      if (response) {
        getDynamicLogger(response, "dataSystemAll");
        setShowDeleteConfirmation(false);
        setItemToDelete(null);
        setLoading(false);
        handleClose();
      }
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirmation(false);
    setItemToDelete(null);
  };

  return (
    <div>
      <SideModalContainerNew>
        <div className="relative flex bg-[#FCFCFC] flex-col h-full px-2">
          <div
            style={{
              borderBottom: "1px solid #D9D9D9",
            }}
            className="min-h-16 w-full px-4 flex justify-between bg-white items-center"
          >
            <div>
              <h5 className="text-xl font-bold uppercase text-esblue">
                {detail?.user?.departmentName}
              </h5>
              <small className="text-xs font-normal text-es-gray-100">
                {detail?.user?.email}
              </small>
            </div>
            <img
              onClick={handleClose}
              className="cursor-pointer"
              src={Close}
              alt="close"
            />
          </div>
          <div className="flex justify-end items-center px-6">
            <button
              onClick={() => handleAdd(detail?._id)}
              className="w-fit flex items-center gap-2 px-4 text-white bg-primary text-sm rounded py-2 mt-4 mb-2"
            >
              <PlusIcon size={20} />
              Add New
            </button>
          </div>

          <div className="px-6">
            <table className="w-full">
              <thead>
                <tr className="">
                  <th className="p-3 text-xs text-left font-medium text-[#667085]">
                    ERP Module
                  </th>
                  <th className="p-3 text-xs text-left font-medium text-[#667085]">
                    Date Invited
                  </th>
                  <th className="p-3 text-xs text-left font-medium text-[#667085]"></th>
                </tr>
              </thead>
              <tbody>
                {dataSystemAll?.docs?.map((contact: any, i: number) => (
                  <tr
                    style={{
                      background: i % 2 === 0 ? "#F9FAFB" : "transparent",
                    }}
                    key={contact._id}
                    className="h-20"
                  >
                    <td className="p-3 text-sm text-sec font-medium">
                      {contact?.erpModule}
                    </td>
                    <td className="p-3 text-sm font-medium text-[#667085]">
                      {moment(contact?.createdAt)?.format("DD/MM/YY")}
                    </td>
                    <td className="p-3 flex justify-center items-center h-20 space-x-2 gap-3">
                      <div className="relative flex gap-2">
                        <button className="text-gray-500 hover:text-gray-700">
                          <View
                            onClick={() => {
                              // setModal(contact?._id);
                              navigate(`/invitation/${contact._id}`);
                            }}
                            size={18}
                          />
                        </button>
                        <button className="text-gray-500 hover:text-gray-700">
                          <Trash2
                            onClick={() => handleDeleteClick(contact._id)}
                            size={18}
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </SideModalContainerNew>

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteConfirmation}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        loading={loading}
        title="Confirm Delete"
        message="Are you sure you want to delete this data system? This action cannot be undone."
      />

      {modal && (
        <DetailsModal handleClose={() => setModal("")} detail={modal} />
      )}
    </div>
  );
};
